import CardGrid, { CardGridWithInfinteScroll } from './CardGrid.styled'

export { CardGridWithInfinteScroll }
export default CardGrid
